export enum PrivacyEnum {
  Private = "Private",
  Public = "Public",
  Followers = "Followers",
}
export enum PremiumLevel {
  Basic = "Basic",
  Pro = "Pro",
  Elite = "Elite",
}
export enum AccountRoleEnum {
  Player = "player",
  Trainer = "trainer",
  Support = "support",
  Fan = "fan",
  undefined = "undefined",
}
export enum HomeAwayEnum {
  Home = "Home",
  Away = "Away",
}
export enum PreferredPositionEnum {
  Goalkeeper = "GK",
  Centreback = "CB",
  Leftback = "LB",
  Rightback = "RB",
  DefensiveMidfielder = "CDM",
  CentralMidfielder = "CM",
  LeftMidfielder = "LM",
  RightMidfielder = "RM",
  AttackingMidfielder = "CAM",
  LeftWinger = "LW",
  RightWinger = "RW",
  Striker = "ST",
}
export enum TeamType {
  knvb = "knvb",
  custom = "custom",
}
export interface IFilterOrganizationParams {
  [key: string]: string;
  page: string;
  LeagueId: string;
  NameFilter: string;
  pageSize: string;
}
export interface IFilterPagingParams {
  [key: string]: string;
  page: string;
  filter: string;
  pageSize: string;
}
export interface ISearchLeaguesParams {
  [key: string]: string;
  page: string;
  CountryCode: string;
  NameFilter: string;
  pageSize: string;
}
export interface ISearchTeamsParams {
  [key: string]: string;
  page: string;
  TeamNameFilter: string;
  OrganizationIdFilter: string;
  LeagueIdFilter: string;
  pageSize: string;
}

export interface IMiniGamesAccuracyParams {
  GoalPositionX: number;
  GoalPositionY: number;
}
export interface IMiniGamesAttemptParams {
  sessionId?: string;
  attemptId?: string;
}
export interface ISearchMiniGamesAttemptsParams {
  [key: string]: string;
  sessionId: string;
  page: string;

  pageSize: string;
}
export interface ISearchMiniGamesParams {
  [key: string]: string;
  page: string;
  status: string;
  pageSize: string;
}
export interface ISearchMatchesParams {
  [key: string]: string;
  page: string;
  TeamIdFilter: string;
  OrganizationIdFilter: string;
  pageSize: string;
  "ScheduledAtFilter.From": string;
  "ScheduledAtFilter.To": string;
}
export interface ISearchActivityParams {
  [key: string]: string;
  page: string;
  filter: string;
  SearchFilter: string;
  pageSize: string;
  TeamIdFilter: string;
  OrganizationIdFilter: string;
  PublishStateFilter: PublishState | string;
  "CreatedAtFilter.From": string;
  "CreatedAtFilter.To": string;
}
// Activity interfaces
export interface IActivitiesApiCall {
  activities: IActivities[];
  page: number;
  total: number;
}

export enum PublishState {
  Published = "published",
  Draft = "draft",
}
export enum ThemeColor {
  Primary = "primary",
  Secondary = "secondary",
}
export enum ActivityAudience {
  All = "all",
  Team = "team",
  Organization = "organization",
}

export enum ManagementRolesEnum {
  "admin" = "admin",
  "scheduler" = "scheduler",
  "scorekeeper" = "scorekeeper",
  "contentCreator" = "contentCreator",
}
export enum RoleEnum {
  "Player" = "Player",
  "Trainer" = "Trainer",
  "Support" = "Support",
}
export enum MiniGamesStatusEnum {
  verified = "verified",
  correct = "correct",
  error = "error",
  disputed = "disputed",
  undefined = "undefined",
  verificationRequired = "verificationRequired",
  verifying = "verifying",
}
export enum OrganizationEnum {
  Default = "default",
  Club = "club",
  HighSchool = "highSchool",
  University = "university",
  College = "college",
}

export interface IExportData {
  organizationId?: string;
  teamId?: string;
  startDate: string;
  endDate: string;
}

export interface IActivityContentButton {
  text: string | null;
  url: string | null;
  style: ThemeColor | null;
}
export interface IActivityMediaContent {
  type: string | null;
  imageName?: string | null;
  imageUrl?: string;
  VideoUrl?: string;
  videoUrl?: string;
  ThumbnailUrl?: string;
  sas?: string;
}
export interface IActivityContent {
  title?: string | null;
  contentTitle?: string | null;
  contentBody?: string | null;
  pushNotificationContentTitle?: string | null;
  pushNotificationContentBody?: string | null;
  button?: IActivityContentButton | null;
  mediaContent?: IActivityMediaContent | null;
}
export interface IActivityAdd {
  teams: string[];
  organizations: string[];
  activityAudience?: ActivityAudience;
  shareWithFollowers: boolean;
  pinned: boolean;
  publishState: PublishState;
  sendPublishNotification: boolean;
  content: {
    nl: IActivityContent;
    en: IActivityContent;
  };
}

export interface IActivities {
  createdAtUtc: string;
  updatedAtUtc: string;
  publishedAtUtc: string;

  id: string;
  teams: ITeam[];
  isRemoved: boolean;
  organizations: IOrganization[];
  shareWithFollowers: boolean;
  pinned: boolean;
  publishState: PublishState;
  sendPublishNotification: boolean;
  content: {
    nl: IActivityContent;
    en: IActivityContent;
  };
}

export interface IActivityEdit {
  teams: string[];
  organizations: string[];
  shareWithFollowers: boolean;
  pinned: boolean;
  publishState: PublishState;
  content: {
    nl: IActivityContent;
    en: IActivityContent;
  };
}
export interface IMiniGamesApiCall {
  sessions: IMiniGames[];
  page: number;
  total: number;
}
export interface IMiniGamesAttemptsApiCall {
  attempts: IMiniGamesAttempts[];
  page: number;
  total: number;
}
// Team interfaces
export interface IMiniGamesAttempt {
  attemptScore: {
    speed: number;
    accuracy: number;
    points: number;
    isGoal: boolean;
    goalPosition: {
      x: number;
      y: number;
    };
    video: {
      videoUrl: string;
      originalVideoUrl: string;
      downloadableVideoUrl: string;
    };
    shotFrame: number;
  };
  verificationScore: {
    speed: number;
    accuracy: number;
    points: number;
    isGoal: boolean;
    goalPosition: {
      x: number;
      y: number;
    };
    video: {
      videoUrl: string;
      originalVideoUrl: string;
      downloadableVideoUrl: string;
    };
    shotFrame: number;
  };
  verificationStatus: string;
  dateTimeUtc: string;
  round: number;
}
export interface IMiniGamesAttempts {
  id: string;
  sessionId: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    imageUrl: string;
  };
  dateTimeUtc: string;
  isGoal: boolean;
  round: number;

  score: {
    speed: 0;
    accuracy: 0;
    points: 0;
  };
  penaltyStatus: MiniGamesStatusEnum;
  verificationStatus: string;
}

export interface IMiniGames {
  id: string;
  name: string;
  type: string;
  dateTimeUtc: string;
  createdBy: {
    id: string;
    firstName: string;
    lastName: string;
  };
  numberOfParticipants: 0;
  numberOfAttempts: 0;
  status: MiniGamesStatusEnum;
}
export interface IMatchesApiCall {
  matches: IMatches[];
  page: number;
  total: number;
}
export interface IMatches {
  id: string;
  team: ITeamInMatch;
  opponent: ITeamInMatch;
  scheduledAtUtc: string;
  arrivalTimeUtc: string;
  arrivalLocation: string;
}
export interface IMatchAdd {
  teamId: string;
  opponentId: string;
  scheduledAtUtc: string;

  isAway: boolean;
  arrivalTimeUtc: string;
  arrivalLocation: string;
}
export interface IMatchEdit {
  matchId: string | undefined;
  homeTeamId: string | undefined;
  scheduledAtUtc: string | undefined;
  arrivalTimeUtc?: string | undefined;
  arrivalLocation?: string;
}
export interface IOpponentAdd {
  id?: string;
  name: string;
  teamId?: string;
  organizationId?: string;
}
export interface IOpponent {
  id: string;
  name: string;
  teamId: string;
  nameAbbreviation: string;
  logoUrl: string;
  organization: {
    id: string;
    name: string;
    shortName: string;
    logoUrl: string;
    countryCode: string;
    type: string;
  };
}
export interface IOpponents {
  opponents: IOpponent[];
}
//Team Interfaces
export interface ITeamsApiCall {
  teams: ITeam[];
  page: number;
  total: number | undefined;
}
export interface ITeamAdd {
  id?: string;
  teamId?: string;
  name?: string;
  nameAbbreviation?: string;
  sportType?: string;
  isGhost?: boolean;
  isHistoric?: boolean;
  organizationId?: string;
  seasonId?: string;
  leagueId?: string;
  logoUrl?: string;
  members: ITeamMember[];
}
export interface ITeamEdit {
  id?: string;
  name?: string;
  nameAbbreviation?: string;
  sportType?: string;
  isGhost?: boolean;
  isHistoric?: boolean;
  logoUrl?: string;
  seasonId?: string;
}
export interface IUpdateTeamOfficialStatus {
  teamId: string;
  isOfficial: boolean;
}
export interface ITeam {
  id: string;
  teamId?: string;
  fullName?: string;
  shortName?: string;
  name?: string;
  nameAbbreviation?: string;
  organizationId?: string;
  leagueId?: string;
  isGhost?: boolean;
  isArchived?: boolean;
  isManagedByOrganization?: boolean;
  isOfficial?: boolean;
  logoUrl?: string;
  isHistoric?: boolean;
  inviteCode: string;
  sportType: string;
  inviteLink: string;
  season: ISeason;
  members: ITeamMember[];
  // players: ITeamMember[];
  // trainers: ITeamMember[];
  // support: ITeamMember[];
  // adminIds: string[];
  // schedulerIds: string[];
  // contentCreatorIds: string[];
  // scorekeeperIds: string[];
  league?: ILeague;

  organization: IOrganization | null;
  type: TeamType;
}

export interface ITeamInMatch {
  id: string;
  name: string;
  nameAbbreviation?: string;
  logoUrl?: string;
  isHome: boolean;
  league?: ILeague;
}

export interface ILeaguesApiCall {
  leagues: ILeague[];
  page: number;
  total: number;
}
export interface ISeason {
  id?: string;
  name: string;
  startsAtUtc: string;
  endsAtUtc: string;
  isActive?: boolean;
}
export interface ILeagueAdd {
  id?: string;
  name: string;
  logoUrl?: string;
  sportType: string;
  countryCode: string;
  isVerified?: boolean;
  isGhost: boolean;
  isHighlighted: boolean;
  isDefault: boolean;
  seasons: ISeason[];
  parentLeagueId?: string;
}
export interface ILeague {
  id: string;
  name: string;
  shortName: string;
  countryCode: string;
  sportType: string;
  isVerified?: boolean;
  isHighlighted: boolean;
  isGhost: boolean;
  isDefault: boolean;
  logoUrl?: string | undefined;
  logoName?: string | undefined;
  parentLeagueId: string;
  seasons: ISeason[];
}

//Organizations Interfaces
export interface IOrganizarionsApiCall {
  organizations: IOrganization[];
  page: number;
  total: number;
}
export interface ITeamBooster {
  userId: string;
  displayName: string;
  expiresAtUtc: string;
  willRenew: boolean;
}
export interface ITeamBoost {
  teamBoostId: string;
  userId: string;
  teamId: string;
  source: string;
  expiresAtUtc: string;
  willRenew: boolean;
}
export interface ITeamBoostPerUser {
  availableBoosts: number;
  teamBoosts: ITeamBoost[];
}

export interface IBoostStatus {
  boostLevel: number;
  teamBoosters: ITeamBooster[];
  boostStatus: IBoostStatus;
}
export interface IRemoveMemberFromTeam {
  teamId: string;
  memberId: string;
}
export interface IAddMemberToTeam {
  userId: string;
  teamId: string;
  roles: MemberRoleEnum[];
  isAdmin: boolean;
}
export interface IUpdateMemberToTeam {
  id: string;
  teamId: string;
  teamManagementRoles: MemberTeamManagementRoleEnum[];
  rolesData: MemberRoleEnum[];
}
export interface IOrganizationAdd {
  id?: string;
  name: string;
  shortName: string;
  logoUrl?: string | undefined;
  logoName?: string | undefined;
  isGhost: boolean;
  leagueId: string | null;
  countryCode: string | null;
  type?: OrganizationEnum;
  sportType: string | null;
  address: {
    line1: string;
    line2: string;
    zipCode: string;
    city: string;
    region: string;
  };
}
export interface IOrganizationUser {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  imageUrl: string;
}

export interface IOrganization {
  id: string;
  name: string;
  shortName: string;
  leagueId: string | null;
  countryCode: string | null;
  logoUrl?: string | undefined;
  logoName?: string | undefined;
  isGhost: boolean;
  type?: OrganizationEnum;
  sportType: string | null;
  address: {
    line1: string;
    line2: string;
    zipCode: string;
    city: string;
    region?: string;
    mapImageUrl?: string;
    coordinates?: {
      lat: number;
      lon: number;
    };
  };
  owner?: IOrganizationUser;
  admins?: IOrganizationUser[];
}

//User Interfaces
export interface IUsersApiCall {
  users: IUsers[];
  page: number;
  total: number;
}
export interface IUsers {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  isGhost: boolean;
  premiumLevel: PremiumLevel;
  profileImageUrl: string | undefined;
  imageUrl: string | undefined;
  isPreUser: boolean;
}
// export interface ITeamMember {
//   id: string;
//   role: RoleEnum;
//   teamManagementRoles?: ManagementRolesEnum[];
//   firstName?: string;
//   lastName?: string;
//   email?: string;
//   imageUrl?: string | undefined;
//   profileImageUrl?: string | undefined;
//   isPreUser?: boolean;
//   premiumLevel?: string;
// }

export enum MemberRoleEnum {
  player = "player",

  coach = "coach",
  trainer = "trainer",
  assistant = "assistant",
  manager = "manager",

  parent = "parent",
  support = "support",
}
//NEW Member
export interface IRoleData {
  roleType: MemberRoleEnum;
  rolePriority: number;
  firstPreferredPosition?: PreferredPositionEnum;
  secondPreferredPosition?: PreferredPositionEnum;
  thirdPreferredPosition?: PreferredPositionEnum;
  foot?: string;
  playerNumber?: string;
  isGuest: boolean;
}
export enum MemberTeamManagementRoleEnum {
  admin = "admin",
  scheduler = "scheduler",
  scorekeeper = "scorekeeper",
  contentCreator = "contentCreator",
}
export enum GenderUserEnum {
  Male = "male",
  Female = "female",
  Other = "other",
}
export interface ITeamMember {
  id: string;
  firstName: string;
  lastName: string;
  imageUrl?: string;
  profileImageUrl?: string;
  ownerId?: string;
  email?: string;
  phoneNumber?: string;
  gender?: GenderUserEnum;
  dateOfBirthUtc: string;
  weightInKg: number;
  heightInCm: number;
  teamManagementRoles?: MemberTeamManagementRoleEnum[];
  rolesData: IRoleData[];
}

export interface IUser {
  id: string;
  email: string;
  dateOfBirth: string;
  isVerified: boolean;
  isGhost?: boolean;
  accountRole?: AccountRoleEnum;
  premiumLevel?: PremiumLevel;
  teams?: [{ team: ITeam; userRoles: string[] }];
  profile: {
    firstName: string;
    lastName: string;
    privacy: PrivacyEnum;
    imageUrl: string | undefined;
    preferredPosition: PreferredPositionEnum | undefined;
  };
  clubAdminOf?: string[];
}
export interface IUserEdit {
  birthday: string;
  email: string;
  isGhost: boolean;
  accountRole?: AccountRoleEnum;
  profile: {
    firstName: string;
    lastName: string;
    privacy: PrivacyEnum;
    imageFileName: string | undefined;
    preferredPosition: PreferredPositionEnum | string;
  };
  clubAdminOf?: string[];
}
export interface IUserAdd {
  password: string;
  email: string;
  birthday: string;
  isGhost: boolean;
  accountRole?: AccountRoleEnum;
  profile: {
    firstName: string;
    lastName: string;
    privacy: PrivacyEnum;
    imageFileName: string | null;
    preferredPosition: PreferredPositionEnum | string;
  };
  clubAdminOf?: string[];
}

// Secure storage implementation with Web Crypto API
const secureStorage = {
  // Store the encryption key in memory during the session
  _encryptionKey: null as CryptoKey | null,

  // Generate or retrieve encryption key
  async getEncryptionKey() {
    if (!this._encryptionKey) {
      // Try to get key material from localStorage (persists across window closures)
      const storedKeyMaterial = localStorage.getItem("keyMaterial");

      if (storedKeyMaterial) {
        // Derive key from stored material
        const keyMaterial = new Uint8Array(JSON.parse(storedKeyMaterial));
        this._encryptionKey = await window.crypto.subtle.importKey(
          "raw",
          keyMaterial,
          { name: "AES-GCM" },
          false,
          ["encrypt", "decrypt"]
        );
      } else {
        // Generate new key if none exists
        const keyMaterial = window.crypto.getRandomValues(new Uint8Array(32));
        localStorage.setItem(
          "keyMaterial",
          JSON.stringify(Array.from(keyMaterial))
        );

        this._encryptionKey = await window.crypto.subtle.importKey(
          "raw",
          keyMaterial,
          { name: "AES-GCM" },
          false,
          ["encrypt", "decrypt"]
        );
      }
    }
    return this._encryptionKey;
  },

  // Encrypt data before storing
  async encrypt(data: string) {
    const key = await this.getEncryptionKey();
    const encoder = new TextEncoder();
    const iv = window.crypto.getRandomValues(new Uint8Array(12));

    const encryptedData = await window.crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv,
      },
      key,
      encoder.encode(data)
    );

    // Combine IV and encrypted data and convert to base64 for storage
    const combined = new Uint8Array(
      iv.length + new Uint8Array(encryptedData).length
    );
    combined.set(iv);
    combined.set(new Uint8Array(encryptedData), iv.length);

    return btoa(String.fromCharCode.apply(null, Array.from(combined)));
  },

  // Decrypt stored data
  async decrypt(encryptedData: string) {
    const key = await this.getEncryptionKey();
    const decoder = new TextDecoder();
    const combined = Uint8Array.from(atob(encryptedData), (c) =>
      c.charCodeAt(0)
    );

    // Extract IV and ciphertext
    const iv = combined.slice(0, 12);
    const ciphertext = combined.slice(12);

    try {
      const decrypted = await window.crypto.subtle.decrypt(
        {
          name: "AES-GCM",
          iv,
        },
        key,
        ciphertext
      );

      return decoder.decode(decrypted);
    } catch (e) {
      console.error("Decryption failed", e);
      return "";
    }
  },

  // Store encrypted token
  async setToken(token: string | null) {
    if (!token) {
      window.localStorage.removeItem("secureToken");
      return;
    }

    try {
      const encryptedToken = await this.encrypt(token);
      window.localStorage.setItem("secureToken", encryptedToken);
    } catch (e) {
      console.error("Failed to encrypt token", e);
    }
  },

  // Get and decrypt token
  async getToken() {
    const encryptedToken = window.localStorage.getItem("secureToken");
    if (!encryptedToken) return "";

    try {
      return await this.decrypt(encryptedToken);
    } catch (e) {
      console.error("Failed to decrypt token", e);
      return "";
    }
  },

  // Store encrypted refresh token
  async setRefreshToken(refreshToken: string | null) {
    if (!refreshToken) {
      window.localStorage.removeItem("secureRefreshToken");
      return;
    }

    try {
      const encryptedToken = await this.encrypt(refreshToken);
      window.localStorage.setItem("secureRefreshToken", encryptedToken);
    } catch (e) {
      console.error("Failed to encrypt refresh token", e);
    }
  },

  // Get and decrypt refresh token
  async getRefreshToken() {
    const encryptedToken = window.localStorage.getItem("secureRefreshToken");
    if (!encryptedToken) return "";

    try {
      return await this.decrypt(encryptedToken);
    } catch (e) {
      console.error("Failed to decrypt refresh token", e);
      return "";
    }
  },

  // Clear all tokens and key material
  clearToken() {
    window.localStorage.removeItem("secureToken");
    window.localStorage.removeItem("secureRefreshToken");
    localStorage.removeItem("keyMaterial");
    this._encryptionKey = null;
  },
};

// Simple storage implementation for development
const simpleStorage = {
  getToken: () =>
    JSON.parse(window.localStorage.getItem("token") || JSON.stringify("")),
  setToken: (token: string | null) =>
    window.localStorage.setItem("token", JSON.stringify(token)),
  getRefreshToken: () =>
    JSON.parse(
      window.localStorage.getItem("refreshToken") || JSON.stringify("")
    ),
  setRefreshToken: (refreshToken: string | null) =>
    window.localStorage.setItem("refreshToken", JSON.stringify(refreshToken)),
  clearToken: () => {
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("token");
  },
};

// Export the appropriate storage implementation based on environment
export const storage =
  process.env.REACT_APP_ENV === "PROD" ? secureStorage : simpleStorage;

export function getCountries(lang = "en") {
  const A = 65;
  const Z = 90;
  const countryName = new Intl.DisplayNames([lang], { type: "region" });
  const countries = [];
  for (let i = A; i <= Z; ++i) {
    for (let j = A; j <= Z; ++j) {
      let code = String.fromCharCode(i) + String.fromCharCode(j);
      let name = countryName.of(code);
      if (code !== name) {
        countries.push({ code, name });
      }
    }
  }
  return countries;
}

export interface ICountry {
  name: string;
  code: string;
}
export const getMingleCountries = (): ICountry[] => {
  return [
    { name: "United Arab Emirates", code: "AE" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Anguilla", code: "AI" },
    { name: "Argentina", code: "AR" },
    { name: "Austria", code: "AT" },
    { name: "Australia", code: "AU" },
    { name: "Aruba", code: "AW" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Barbados", code: "BB" },
    { name: "Belgium", code: "BE" },
    { name: "Bulgaria", code: "BG" },
    { name: "Bahrain", code: "BH" },
    { name: "Bermuda", code: "BM" },
    { name: "Bolivia", code: "BO" },
    { name: "Brazil", code: "BR" },
    { name: "Bahamas", code: "BS" },
    { name: "Belize", code: "BZ" },
    { name: "Canada", code: "CA" },
    { name: "Switzerland", code: "CH" },
    { name: "Chile", code: "CL" },
    { name: "Colombia", code: "CO" },
    { name: "Costa Rica", code: "CR" },
    { name: "Cape Verde", code: "CV" },
    { name: "Curaçao", code: "CW" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Germany", code: "DE" },
    { name: "Denmark", code: "DK" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Estonia", code: "EE" },
    { name: "Spain", code: "ES" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "United Kingdom", code: "GB" },
    { name: "Grenada", code: "GD" },
    { name: "Greece", code: "GR" },
    { name: "Guatemala", code: "GT" },
    { name: "Guyana", code: "GY" },
    { name: "Hong Kong", code: "HK" },
    { name: "Honduras", code: "HN" },
    { name: "Croatia", code: "HR" },
    { name: "Haiti", code: "HT" },
    { name: "Hungary", code: "HU" },
    { name: "Ireland", code: "IE" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "St. Kitts and Nevis", code: "KN" },
    { name: "Cayman Islands", code: "KY" },
    { name: "St. Lucia", code: "LC" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Latvia", code: "LV" },
    { name: "Montenegro", code: "ME" },
    { name: "North Macedonia", code: "MK" },
    { name: "Montserrat", code: "MS" },
    { name: "Malta", code: "MT" },
    { name: "Mexico", code: "MX" },
    { name: "Malaysia", code: "MY" },
    { name: "Nicaragua", code: "NI" },
    { name: "Netherlands", code: "NL" },
    { name: "Norway", code: "NO" },
    { name: "New Zealand", code: "NZ" },
    { name: "Panama", code: "PA" },
    { name: "Peru", code: "PE" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Paraguay", code: "PY" },
    { name: "Qatar", code: "QA" },
    { name: "Romania", code: "RO" },
    { name: "Serbia", code: "RS" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Sweden", code: "SE" },
    { name: "Singapore", code: "SG" },
    { name: "Slovenia", code: "SI" },
    { name: "Slovakia", code: "SK" },
    { name: "Suriname", code: "SR" },
    { name: "El Salvador", code: "SV" },
    { name: "Thailand", code: "TH" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Türkiye", code: "TR" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Taiwan", code: "TW" },
    { name: "Ukraine", code: "UA" },
    { name: "United States of America", code: "US" },
    { name: "Uruguay", code: "UY" },
    { name: "St. Vincent and the Grenadines", code: "VC" },
    { name: "Venezuela", code: "VE" },
    { name: "British Virgin Islands", code: "VG" },
    { name: "Kosovo", code: "XK" },
    { name: "Republic of Korea", code: "KR" },
  ];
};
